// client/src/components/messages/AttachmentRenderer.js
import React from 'react';
import { Box, Card, CardMedia, Typography, Link, Chip } from '@mui/material';
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import TextSnippetIcon from '@mui/icons-material/TextSnippet';
import FolderZipIcon from '@mui/icons-material/FolderZip';

const AttachmentRenderer = ({ attachments }) => {
  if (!attachments || attachments.length === 0) return null;

  const getFileIcon = (mimetype) => {
    if (mimetype.startsWith('image/')) return null; // Images shown directly
    if (mimetype === 'application/pdf') return <PictureAsPdfIcon />;
    if (mimetype === 'text/plain') return <TextSnippetIcon />;
    if (mimetype.includes('zip')) return <FolderZipIcon />;
    return <InsertDriveFileIcon />;
  };

  return (
    <Box sx={{ mt: 1, display: 'flex', flexDirection: 'column', gap: 1 }}>
      {attachments.map((att, idx) => {
        const isImage = att.mimetype.startsWith('image/');
        
        if (isImage) {
          return (
            <Card key={idx} sx={{ maxWidth: 400 }}>
              <CardMedia
                component="img"
                image={att.url}
                alt={att.originalName}
                sx={{ cursor: 'pointer' }}
                onClick={() => window.open(att.url, '_blank')}
              />
              <Box sx={{ p: 1 }}>
                <Typography variant="caption" color="text.secondary">
                  {att.originalName} ({(att.size / 1024).toFixed(1)}KB)
                </Typography>
              </Box>
            </Card>
          );
        }

        // Non-image files
        return (
          <Link
            key={idx}
            href={att.url}
            target="_blank"
            rel="noopener noreferrer"
            underline="none"
          >
            <Chip
              icon={getFileIcon(att.mimetype)}
              label={`${att.originalName} (${(att.size / 1024).toFixed(1)}KB)`}
              clickable
              color="primary"
              variant="outlined"
            />
          </Link>
        );
      })}
    </Box>
  );
};

export default AttachmentRenderer;
